import LabelTableCell from 'Components/LabelTableCell'
import StyledTableRow from 'Components/StyledTableRow'
import TranslatedField from 'Components/TranslatedField'
import { useAuthorityContext } from 'Services/common/Features/Authority/Context/authorityContext'
import type { ZoneDefinition } from 'Services/ProductManagement/Features/ZoneDefinition/types'
import { datetimeFormatter, showValueOrHyphen } from 'Util/formatters'
import getTranslation from 'Util/getTranslation'
import {
  Paper,
  styled,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  Typography
} from '@mui/material'
import { t } from 'ttag'

const StyledTableCell = styled(LabelTableCell)`
  width: 40%;
`

interface ZoneDefinitionDetailsProps {
  zoneDefinition: ZoneDefinition
}

export function ZoneDefinitionDetails({ zoneDefinition }: Readonly<ZoneDefinitionDetailsProps>) {
  const { getCodespaceNameByCode } = useAuthorityContext()

  return (
    <TableContainer component={Paper}>
      <Table sx={{ td: { border: 'none' } }} aria-label={t`Details table`}>
        <TableBody>
          <StyledTableRow>
            <StyledTableCell>{t`Identifier`}</StyledTableCell>
            <TableCell>{showValueOrHyphen(zoneDefinition.id)}</TableCell>
          </StyledTableRow>
          <StyledTableRow>
            <StyledTableCell>{t`Authority`}</StyledTableCell>
            <TableCell>{getCodespaceNameByCode(zoneDefinition.pta)}</TableCell>
          </StyledTableRow>
          <StyledTableRow>
            <StyledTableCell>{t`Created`}</StyledTableCell>
            <TableCell>{datetimeFormatter(zoneDefinition.created_timestamp)}</TableCell>
          </StyledTableRow>
          <StyledTableRow>
            <StyledTableCell>{t`Modified`}</StyledTableCell>
            <TableCell>{datetimeFormatter(zoneDefinition.modified_timestamp)}</TableCell>
          </StyledTableRow>
          {Object.entries(zoneDefinition.translations).map(([key, translation]) => (
            <StyledTableRow key={key}>
              <StyledTableCell>{key}</StyledTableCell>
              <TableCell>
                <TranslatedField key="value" field="value" translations={translation} />
              </TableCell>
            </StyledTableRow>
          ))}
          <StyledTableRow>
            <StyledTableCell>{t`Special zones`}</StyledTableCell>
            <TableCell>
              {zoneDefinition.special_zones.map(zone => (
                <Typography variant="body2" key={zone.join('')}>
                  {zone
                    .map(zoneId => getTranslation(zoneDefinition.translations[zoneId], 'fi').value)
                    .join('+')}
                </Typography>
              ))}
            </TableCell>
          </StyledTableRow>
        </TableBody>
      </Table>
    </TableContainer>
  )
}
